module.exports = __webpack_public_path__ + "static/img/secondaryxinancaijin.676d201.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ggw_img/secondaryxinancaijin.png
// module id = JHyD
// module chunks = 46